module.exports = __webpack_public_path__ + "static/mk11_1920x900-tablet.d42de0e8.png";